import { api } from '.';
import { SectionType } from '../constants';
import { IRecommendCuration, ISection } from '../model';
import { toQueryString } from '../utils/misc';

export const fetchSections = async (type: SectionType) => {
  const { data } = await api.get<ISection[]>(
    `/sections/${toQueryString({ type })}`
  );
  return data;
};

export const fetchSection = async (sectionId: number) => {
  const { data } = await api.get<ISection>(`/sections/${sectionId}/`);
  return data;
};

export const fetchCuration = async (sectionId: number) => {
  const { data } = await api.get<ISection>(`/sections/${sectionId}/`);
  return data;
};

export const fetchCurationByType = async (type: string) => {
  const { data } = await api.get<IRecommendCuration>(`/curations/${type}/`);
  return data;
};
